import { render, staticRenderFns } from "./ImportaPoliticaVendas.vue?vue&type=template&id=35a7edf6&scoped=true&"
import script from "./ImportaPoliticaVendas.vue?vue&type=script&lang=js&"
export * from "./ImportaPoliticaVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7edf6",
  null
  
)

export default component.exports